var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _g2, _path14, _g3, _path15, _g4, _path16, _g5, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBallsBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 277,
    viewBox: "0 0 182 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.213 88.5691C144.884 95.3456 142.366 103.813 135.588 107.485C128.812 111.156 120.343 108.64 116.672 101.864C113.002 95.0889 115.52 86.6214 122.297 82.9501C129.075 79.2781 137.543 81.794 141.213 88.5691Z",
    fill: "#0AA8E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.001 68.0979C182.672 74.8744 180.154 83.342 173.376 87.014C166.599 90.6852 158.131 88.1693 154.46 81.3928C150.79 74.6177 153.307 66.1502 160.084 62.4789C166.862 58.8069 175.33 61.3228 179.001 68.0979Z",
    fill: "#0AA8E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.463 119.068C163.501 126.523 160.729 135.837 153.278 139.874C145.822 143.913 136.506 141.147 132.467 133.693C128.429 126.239 131.202 116.926 138.658 112.887C146.109 108.85 155.425 111.614 159.463 119.068Z",
    fill: "#0AA8E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.724 98.883C200.545 105.936 197.924 114.749 190.87 118.571C183.815 122.393 175 119.775 171.179 112.722C167.358 105.669 169.98 96.8549 177.035 93.0332C184.089 89.2115 192.903 91.8302 196.724 98.883Z",
    fill: "#0AA8E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.259 148.958C179.297 156.412 176.526 165.727 169.074 169.764C161.617 173.804 152.301 171.037 148.263 163.582C144.225 156.128 146.996 146.816 154.454 142.776C161.905 138.739 171.221 141.503 175.259 148.958Z",
    fill: "#0AA8E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.52 128.773C216.34 135.825 213.719 144.639 206.665 148.461C199.611 152.282 190.795 149.664 186.974 142.612C183.153 135.559 185.776 126.745 192.83 122.923C199.884 119.101 208.699 121.72 212.52 128.773Z",
    fill: "#0AA8E3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.681 179.271C195.719 186.725 192.946 196.038 185.495 200.074C178.037 204.114 168.723 201.35 164.685 193.895C160.647 186.441 163.418 177.129 170.876 173.089C178.327 169.052 187.643 171.816 191.681 179.271Z",
    fill: "#0AA8E3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.309 209.964C212.347 217.419 209.574 226.731 202.123 230.768C194.665 234.808 185.351 232.043 181.313 224.589C177.275 217.135 180.046 207.823 187.504 203.783C194.955 199.746 204.271 202.51 208.309 209.964Z",
    fill: "#0AA8E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.52 128.773C216.34 135.825 213.719 144.639 206.665 148.461C199.611 152.282 190.795 149.664 186.974 142.612C183.153 135.559 185.776 126.745 192.83 122.923C199.884 119.101 208.699 121.72 212.52 128.773Z",
    fill: "#0AA8E3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.803 42.4508C159.784 46.1081 158.425 50.6779 154.767 52.6597C151.109 54.6415 146.536 53.2853 144.554 49.628C142.573 45.9707 143.935 41.3993 147.593 39.4175C151.251 37.4357 155.821 38.7935 157.803 42.4508Z",
    fill: "#0AA8E3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_15783",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 55,
    width: 22,
    height: 22
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.649 62.9727L115.898 55.7955L123.071 69.0369L109.823 76.2141L102.649 62.9727Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_15783)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.484 62.4161C121.466 66.0734 120.107 70.6433 116.448 72.6251C112.79 74.6069 108.217 73.2506 106.236 69.5933C104.255 65.936 105.616 61.3646 109.275 59.3828C112.933 57.401 117.503 58.7588 119.484 62.4161Z",
    fill: "#0AA8E3"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3387 83.1871C85.32 86.8444 83.9611 91.4143 80.3029 93.3961C76.6448 95.3779 72.0717 94.0216 70.0904 90.3643C68.1091 86.707 69.4708 82.1356 73.129 80.1538C76.7872 78.172 81.3574 79.5298 83.3387 83.1871Z",
    fill: "#0AA8E3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_15783",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 231,
    width: 21,
    height: 22
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3828 239.128L78.6303 231.951L85.8042 245.193L72.5567 252.37L65.3828 239.128Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_15783)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2171 238.572C84.1984 242.23 82.8395 246.8 79.1814 248.781C75.5232 250.763 70.9501 249.407 68.9688 245.75C66.9875 242.092 68.3492 237.521 72.0074 235.539C75.6656 233.557 80.2358 234.915 82.2171 238.572Z",
    fill: "#0AA8E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_15783",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 261,
    width: 22,
    height: 22
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5913 269.048L94.8388 261.871L102.013 275.113L88.7652 282.29L81.5913 269.048Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_15783)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4256 268.492C100.407 272.15 99.048 276.719 95.3898 278.701C91.7317 280.683 87.1586 279.327 85.1773 275.669C83.196 272.012 84.5577 267.441 88.2159 265.459C91.8741 263.477 96.4443 264.835 98.4256 268.492Z",
    fill: "#0AA8E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_15783",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 201,
    width: 22,
    height: 22
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9609 208.815L62.2084 201.639L69.3823 214.881L56.1349 222.058L48.9609 208.815Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_15783)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7952 208.26C67.7766 211.917 66.4177 216.487 62.7595 218.469C59.1013 220.451 54.5282 219.094 52.5469 215.437C50.5656 211.78 51.9274 207.208 55.5856 205.227C59.2437 203.245 63.8139 204.603 65.7952 208.26Z",
    fill: "#0AA8E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_15783",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 171,
    width: 22,
    height: 22
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8579 179.091L46.1054 171.915L53.2793 185.157L40.0318 192.334L32.8579 179.091Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_15783)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6922 178.536C51.6735 182.193 50.3146 186.763 46.6564 188.745C42.9983 190.726 38.4252 189.37 36.4439 185.713C34.4626 182.056 35.8243 177.484 39.4825 175.502C43.1407 173.521 47.7109 174.878 49.6922 178.536Z",
    fill: "#0AA8E3"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9162 140.633C57.258 142.615 52.685 141.258 50.7037 137.601C48.7223 133.944 50.0841 129.372 53.7423 127.391C57.4005 125.409 61.9706 126.767 63.952 130.424C65.9333 134.081 64.5744 138.651 60.9162 140.633Z",
    fill: "#0AA8E3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.06 292.262C139.402 294.244 134.829 292.887 132.848 289.23C130.866 285.573 132.228 281.001 135.886 279.02C139.545 277.038 144.115 278.396 146.096 282.053C148.077 285.71 146.718 290.28 143.06 292.262Z",
    fill: "#0AA8E3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1616 178.004C74.1072 181.826 65.293 179.207 61.4722 172.155C57.6514 165.102 60.2722 156.288 67.3267 152.467C74.3811 148.645 83.1953 151.264 87.0161 158.316C90.8369 165.369 88.2161 174.183 81.1616 178.004Z",
    fill: "#0AA8E3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2642 207.728C90.2097 211.55 81.3955 208.931 77.5747 201.878C73.7539 194.826 76.3747 186.012 83.4292 182.19C90.4836 178.369 99.2979 180.987 103.119 188.04C106.939 195.093 104.319 203.906 97.2642 207.728Z",
    fill: "#0AA8E3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.415 237.541C106.637 241.213 98.1687 238.697 94.4975 231.92C90.8272 225.145 93.3451 216.678 100.123 213.005C106.9 209.334 115.368 211.85 119.038 218.625C122.71 225.402 120.192 233.869 113.415 237.541Z",
    fill: "#0AA8E3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.042 268.231C123.264 271.903 114.796 269.388 111.125 262.612C107.454 255.836 109.972 247.368 116.75 243.696C123.527 240.025 131.995 242.541 135.666 249.318C139.336 256.093 136.819 264.56 130.042 268.231Z",
    fill: "#0AA8E3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.913 127.749C92.1348 131.421 83.6667 128.905 79.9963 122.13C76.3252 115.353 78.8431 106.886 85.6213 103.214C92.398 99.5423 100.866 102.058 104.537 108.835C108.208 115.61 105.69 124.077 98.913 127.749Z",
    fill: "#0AA8E3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.101 159.474C109.046 163.296 100.232 160.677 96.4111 153.624C92.5903 146.572 95.2112 137.758 102.266 133.936C109.32 130.115 118.134 132.733 121.955 139.786C125.776 146.839 123.155 155.652 116.101 159.474Z",
    fill: "#0AA8E3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.203 189.196C125.148 193.018 116.334 190.399 112.513 183.347C108.692 176.294 111.313 167.48 118.368 163.659C125.422 159.837 134.236 162.456 138.057 169.508C141.878 176.561 139.257 185.375 132.203 189.196Z",
    fill: "#0AA8E3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.625 219.509C141.57 223.331 132.756 220.712 128.935 213.659C125.114 206.606 127.735 197.793 134.79 193.971C141.844 190.149 150.658 192.768 154.479 199.821C158.3 206.874 155.679 215.687 148.625 219.509Z",
    fill: "#0AA8E3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.038 249.806C157.983 253.628 149.169 251.009 145.348 243.956C141.527 236.904 144.148 228.09 151.203 224.268C158.257 220.447 167.071 223.065 170.892 230.118C174.713 237.171 172.092 245.985 165.038 249.806Z",
    fill: "#0AA8E3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.522 280.234C174.468 284.056 165.653 281.437 161.833 274.384C158.012 267.331 160.633 258.518 167.687 254.696C174.741 250.874 183.556 253.493 187.376 260.546C191.197 267.599 188.576 276.412 181.522 280.234Z",
    fill: "#0AA8E3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.625 219.509C141.57 223.331 132.756 220.712 128.935 213.659C125.114 206.606 127.735 197.793 134.79 193.971C141.844 190.149 150.658 192.768 154.479 199.821C158.3 206.874 155.679 215.687 148.625 219.509Z",
    fill: "#0AA8E3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.038 249.806C157.983 253.628 149.169 251.009 145.348 243.956C141.527 236.904 144.148 228.09 151.203 224.268C158.257 220.447 167.071 223.065 170.892 230.118C174.713 237.171 172.092 245.985 165.038 249.806Z",
    fill: "#0AA8E3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.522 280.234C174.468 284.056 165.653 281.437 161.833 274.384C158.012 267.331 160.633 258.518 167.687 254.696C174.741 250.874 183.556 253.493 187.376 260.546C191.197 267.599 188.576 276.412 181.522 280.234Z",
    fill: "#0AA8E3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBallsBackground);
export default __webpack_public_path__ + "static/media/ic-balls-background.d77839a1c0cd5e66ac0d3130dc95b2cd.svg";
export { ForwardRef as ReactComponent };